import React, { CSSProperties } from 'react';

import * as messages from '@radnuc/messages';

//import { queryN42 } from './Query';

import './BD21ShareButtonDisplay.css'

import share_logo from '@radnuc/react-ui-components/dist//img/share4-32.png'
import share_white_logo from '@radnuc/react-ui-components/dist//img/share4-32-white.png'
import green_check_logo from '@radnuc/react-ui-components/dist//img/check_alt-green-32.png'
import red_x_logo from '@radnuc/react-ui-components/dist//img/x_alt-red-32.png'
import { BD21DataStream } from '../BD21DataStream'; //Instead of Query, BD21 uses Datastreams for communication with backend
import { uuidToString } from '../utils/UUID';
import { HasCloudUI, IsExportsN42 } from '../NodeHealth';

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;

export interface BD21ShareButtonDisplayProps {
    investigation: Investigation;
    linked_dialog_showing: boolean | null;
    style: CSSProperties | undefined;
    queryDatastream?: BD21DataStream;
}

export interface BD21ShareButtonDisplayState {
    share_dropdown_show: boolean | null;
    share_success_state: number;
}

export class BD21ShareButtonDisplay extends React.Component<BD21ShareButtonDisplayProps, BD21ShareButtonDisplayState, {}> {
    timeoutTimer: NodeJS.Timeout | null;

    constructor(props: BD21ShareButtonDisplayProps) {
        super(props)
        this.state = { share_dropdown_show: false, share_success_state: 0 }
        this.timeoutTimer = null;

        this.handleExportBioEncounterClick = this.handleExportBioEncounterClick.bind(this);
        this.handleShareClick = this.handleShareClick.bind(this);
        this.handleExportN42Click = this.handleExportN42Click.bind(this);
    }

    displayShareSuccess() {
        this.setState(state => ({
            share_success_state: 1
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(state => {
            this.setState(state => ({
                share_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 3000);
    }

    displayShareWait() {
        this.setState(state => ({
            share_success_state: 3
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(state => {
            this.setState(state => ({
                share_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 60000);
    }

    displayShareFail() {
        this.setState(state => ({
            share_success_state: 2
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(state => {
            this.setState(state => ({
                share_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 3000);
    }

    handleShareClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            share_dropdown_show: !state.share_dropdown_show
        }));

        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        if (!this.state.share_dropdown_show) {
            this.timeoutTimer = setTimeout(state => {
                this.setState(state => ({
                    share_dropdown_show: false
                }));
                this.timeoutTimer = null;
            }, 5000);

        }
    }

    handleExportBioEncounterClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            share_dropdown_show: false
        }));
        this.displayShareWait();
        const d = new Date(this.props.investigation.start_time);
        const datestring = d.toLocaleString("en-us", {month: "short"})+'_'+d.getDate()+'_'+d.getFullYear();
        const timestring = d.toLocaleString('en-US', {hour:'numeric',minute:'numeric',second:'numeric',hour12: true }).replace(/:/g,"_").replace(" ","_");
        const csv_filename_suffix = datestring+"_"+timestring+'.csv';

        if(this.props.queryDatastream !== undefined && 'type' in this.props.investigation ){

            this.props.queryDatastream.queryEncounterData(this.props.investigation,60000).then(result => {
                console.log(result)
                if(result !== undefined){
                    Object.keys(result).forEach(node_key => {
                        const thisDevice = result[node_key];

                        Object.keys(thisDevice.plottableSensorReadings).forEach(sensor_key => {
                            const thisReading = thisDevice.plottableSensorReadings[sensor_key];
                            if(thisReading.length > 0){
                                let csvContent = "data:text/csv;charset=utf-8,";
                                csvContent += thisReading[0].getCSVLabel()+ "\r\n";
                                thisReading.forEach(element => {
                                    const rowStr = element.getCSVRow();
                                    csvContent += rowStr + "\r\n";
                                });

                                //Save output
                                const csv_filename = "AlarmingSensorData_"+node_key+"_"+sensor_key+"_"+csv_filename_suffix;
                                //let encodedUri = encodeURI(csvContent);
                                let element = document.createElement('a');
                                element.setAttribute('href', encodeURI(csvContent));
                                element.setAttribute('download', csv_filename);

                                element.style.display = 'none';
                                document.body.appendChild(element);

                                element.click();

                                document.body.removeChild(element);

                                this.displayShareSuccess()
                            } else {
                                this.displayShareFail()
                            }
                        });
                    });


                } else {
                    this.displayShareFail();
                }

            }).catch(err => {
                this.displayShareFail();
            });
        } else {
            this.displayShareFail();
        }
    }

    handleExportN42Click(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            share_dropdown_show: false
        }));

        const d = new Date(this.props.investigation.start_time);
        const datestring = d.toLocaleString("en-us", {month: "short"})+'_'+d.getDate()+'_'+d.getFullYear();
        const timestring = d.toLocaleString('en-US', {hour:'numeric',minute:'numeric',second:'numeric',hour12: true }).replace(/:/g,"_").replace(" ","_");
        const n42_filename = "n42_"+datestring+"_"+timestring+'.xml';

        let node_name = "N/A";
        if((this.props.investigation as messages.Encounter.Encounter).node_name !== undefined &&
           (this.props.investigation as messages.Encounter.Encounter).node_name !== null){
            node_name = (this.props.investigation as messages.Encounter.Encounter).node_name;
        }
        const this_uuid = uuidToString(this.props.investigation.id)

        this.props.queryDatastream?.queryCloudN42(node_name,this_uuid,this.props.investigation.start_time).then(result => {
            if(result !== undefined){
                let element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(result));
                element.setAttribute('download', n42_filename);

                element.style.display = 'none';
                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);
                this.displayShareSuccess()
            } else {
                this.displayShareFail();
            }
        }).catch(err => {
            this.displayShareFail();
        });
    }



    componentDidUpdate() {
        if (this.props.linked_dialog_showing && this.state.share_dropdown_show) {
            this.setState(state => ({
                share_dropdown_show: false
            }));
        }
    }

    componentWillUnmount() {
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
    }

    render() {
        //Buttons

        let drowpdownMenuItems;
        if('type' in this.props.investigation){
            if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                //Export options for RAD Inv
                if(IsExportsN42(this.props.investigation.node_name)){
                    drowpdownMenuItems =
                        <>
                            <div className="inv-menu-item" onClick={this.handleExportN42Click}>N42 Summary with Context</div>
                        </>
                }
            } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                //Export options for CHEM Inv
            } else if(this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                //Export options for BIO Inv
                drowpdownMenuItems =
                    <>
                        <div className="inv-menu-item" onClick={this.handleExportBioEncounterClick}>Alarming Sensor Data(CSV)</div>
                    </>
            }
        } else {
            //Export options default investigation
        }

        let share_dropdown;
        if (!this.props.linked_dialog_showing && this.state.share_dropdown_show) {
            share_dropdown =
                <div className="inv-share-dropdown-container inv-menu-item" style={{ display: 'flex', position: 'absolute' }}>
                    <div className="plot-title dropdown share-dropdown-surrogate"></div>
                    <div id="share-select-dropdown-content" className="dropdown-content share-dropdown show" style={this.props.style}>
                        <div className="plot-header" style={{ background: 'orange' }}>
                            <label className="plot-title " style={{ color: 'black', fontSize: '0.9em' }}>Export Investigation</label>
                        </div>
                        {drowpdownMenuItems}
                    </div>
                </div>
        }

        let share_status;
        if (this.state.share_success_state === 1) {
            share_status =
                <img src={green_check_logo} alt="Success" className="inv-share-success inv-menu-button" style={{ cursor: 'pointer' }}></img>
        } else if (this.state.share_success_state === 2) {
            share_status =
                <img src={red_x_logo} alt="Fail" className="inv-share-fail inv-menu-button" style={{ cursor: 'pointer' }}></img>
        } else if (this.state.share_success_state === 3) {
            share_status =
                <div className="inv-share-wait loader"></div>
        } else {
            if (this.state.share_dropdown_show) {
                share_status =
                    <img src={share_white_logo} alt="Share" className="inv-share-open inv-menu-button dropdownevent plot-title dropdown" id="share-select-dropdown" style={{ cursor: 'pointer' }} onClick={this.handleShareClick}></img>
            } else {
                share_status = <img src={share_logo} alt="Share" className="inv-share inv-menu-button dropdownevent plot-title dropdown" id="share-select-dropdown" style={{ opacity:'0.3'}}></img>
                if('type' in this.props.investigation){
                    if(IsExportsN42(this.props.investigation.node_name) && this.props.investigation.type===messages.Encounter.EncounterType.RAD){
                        share_status =
                            <img src={share_logo} alt="Share" className="inv-share inv-menu-button dropdownevent plot-title dropdown" id="share-select-dropdown" style={{ cursor: 'pointer' }} onClick={this.handleShareClick}></img>
                    }
                }

            }
        }

        let share_button =
            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <div id="share-select-dropdown" className="dropdown" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    {share_dropdown}
                    <div className="inv-share-container inv-menu-item">
                        {share_status}
                    </div>
                    <div className="inv-export-all-hidden" style={{ display: 'none'}} onClick={this.handleExportBioEncounterClick}/>
                </div>
            </div>


        return (share_button);
    }
}
export default BD21ShareButtonDisplay
